import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import Header from "../Header";
import { PagingState, CustomPaging } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel } from "@devexpress/dx-react-grid-material-ui";

const getRowId = (row) => row.id;

export default function ResetIdTable() {
  const alert = useAlert();
  const [ids, setIds] = useState("");
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(10);
  const [totalItens, setTotalItens] = useState(0);
  const [loadingTable, setLoadingTable] = useState(false);

  // Função para buscar dados da tabela
  const fetchData = async (specificIds = null, showLoading = false) => {
    if (showLoading) {
      setLoadingTable(true);
    }
    
    try {
      const params = specificIds ? { ids: specificIds.join(',') } : {};
      const response = await http.get("/reset-id/agendamentos", { params });
      
      setRows(response.data.data);
      setTotalItens(response.data.total);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      alert.error("Erro ao carregar dados da tabela");
    } finally {
      if (showLoading) {
        setLoadingTable(false);
      }
    }
  };

  // Função para atualizar a tabela
  const handleRefreshTable = () => {
    if (ids.trim()) {
      const idList = ids.split(",").map(id => id.trim()).filter(id => id);
      fetchData(idList, true);
    } else {
      fetchData(null, true);
    }
  };

  // Carregar dados iniciais
  useEffect(() => {
    fetchData();
  }, []);

  // Atualizar tabela quando IDs mudarem
  useEffect(() => {
    if (ids.trim()) {
      const idList = ids.split(",").map(id => id.trim()).filter(id => id);
      fetchData(idList);
    } else {
      fetchData();
    }
  }, [ids]);

  const handlePage = (page) => {
    setPageIndex(page);
    // Paginação será implementada se necessário
  };

  const handleResetIds = async () => {
    if (!ids.trim()) {
      alert.error("Por favor, insira pelo menos um ID");
      return;
    }

    setLoading(true);
    
    try {
      // Dividir os IDs por vírgula e limpar espaços
      const idList = ids.split(",").map(id => id.trim()).filter(id => id);
      
      if (idList.length === 0) {
        alert.error("Por favor, insira IDs válidos");
        setLoading(false);
        return;
      }

      const response = await http.post("/reset-id", {
        ids: idList
      });

      if (response.data.success) {
        alert.success(`Reset de ${idList.length} ID(s) enviado para processamento no Jenkins`);
        setIds("");
        // Atualizar tabela após reset
        fetchData();
      } else {
        alert.error(response.data.message || "Erro ao enviar reset para Jenkins");
      }

    } catch (error) {
      console.error("Erro ao resetar IDs:", error);
      alert.error("Erro ao realizar reset. Verifique os IDs e tente novamente.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2>Reset de ID</h2>
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox float-e-margins">
                <div className="ibox-title">
                  <h5>Reset de ID</h5>
                  <div className="ibox-tools">
                    <a className="collapse-link">
                      <i className="fa fa-chevron-up"></i>
                    </a>
                  </div>
                </div>
                <div className="ibox-content">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="ids">IDs para Reset:</label>
                        <textarea
                          id="ids"
                          className="form-control"
                          rows="4"
                          placeholder="Digite os IDs separados por vírgula (ex: 123, 456, 789)"
                          value={ids}
                          onChange={(e) => setIds(e.target.value)}
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleResetIds}
                          disabled={loading || !ids.trim()}
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin"></i> Processando...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-refresh"></i> Enviar para Jenkins
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Tabela de Agendamentos */}
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox float-e-margins">
                <div className="ibox-title">
                  <h5>Status dos Agendamentos</h5>
                  <div className="ibox-tools">
                    <button 
                      type="button" 
                      className="btn btn-primary btn-sm" 
                      onClick={handleRefreshTable}
                      disabled={loadingTable}
                      style={{ marginRight: "10px" }}
                    >
                      {loadingTable ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i> Atualizando...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh"></i> Atualizar
                        </>
                      )}
                    </button>
                    <a className="collapse-link">
                      <i className="fa fa-chevron-up"></i>
                    </a>
                  </div>
                </div>
                <div className="ibox-content">
                  <Grid rows={rows} columns={[
                    { name: "doc_num", title: "Doc Num" },
                    { name: "status_bot", title: "Status Bot" },
                    { name: "paciente", title: "Paciente" },
                    { name: "convenio", title: "Convênio" }
                  ]} getRowId={getRowId}>
                    <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={handlePage} />
                    <Table />
                    <TableHeaderRow />
                    <CustomPaging totalCount={totalItens} />
                    <PagingPanel />
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
